"use client";

import { useContext } from "react";
import { UserContext } from "@/contexts/user-context";
import { Button } from "@/components/ui/button";

export const LinkToBackoffice = ({
  type,
  params,
}: {
  type:
    | "calculator"
    | "tutorial"
    | "residency_encyclopedia"
    | "article"
    | "clinical_case"
    | "roadmap_step";
  params: Record<string, string | number>;
}) => {
  const { isEditor } = useContext(UserContext);

  const linkMap: Record<
    typeof type,
    (params: Record<string, string | number>) => string
  > = {
    calculator: ({ id }) => `/admin/calculator/${id}`,
    tutorial: ({ id }) => `/admin/tutorial/${id}`,
    article: ({ id }) => `/admin/article/${id}`,
    residency_encyclopedia: ({ id }) => `/admin/residency-encyclopedia/${id}`,
    clinical_case: ({ id }) => `/admin/clinical-case/${id}`,
    roadmap_step: ({ id }) => `/admin/roadmap/step/${id}`,
  };

  if (!isEditor) {
    return null;
  }

  return (
    <Button className={"my-4"} variant={"secondary"}>
      <a href={linkMap[type](params)} target={"_blank"} rel="noreferrer">
        Edytuj w backoffice
      </a>
    </Button>
  );
};
